'use strict';

(function() {
	angular.module('onboarding.broker.contracts')
		.directive('cobContractList', cobContractList);

	cobContractList.$inject = [
		'subjectObserverMessagesService', 'observerService', 'contractService', 'sessionService', '$state',
		'$stateParams'
	];

	var subjectObserverMessagesService,
		observerService,
		contractService,
		subjectMessages,
		observerMessages,
		sessionService,
		$state,
		$stateParams;

	function cobContractList(_subjectObserverMessagesService_,
		_observerService_,
		_contractService_,
		_sessionService_,
		_state_,
		_$stateParams_) {

		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		contractService = _contractService_;
		sessionService = _sessionService_;
		$state = _state_;
		$stateParams = _$stateParams_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/broker/contracts/contract-list.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		////////////

		function activate() {

			if (sessionService.isAuthorizedInternalAdmin() && !$stateParams.brokerId) {
				$state.go('brokersAdmin');

				return;
			}

			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			registerEventHandlers();

			scope.m = {
				errors: [],
				showAddContractModal: false
			};

			scope.$stateParams = $stateParams;
			scope.contracts = [];
			scope.ajaxIsRunning = false;
			scope.dismissErrors = dismissErrors;
			scope.getContracts = getContracts;
			scope.setFilter = setFilter;
			scope.saveDescription = saveDescription;
			scope.onfileUploadCancel = onfileUploadCancel;
			scope.onFileUploadSave = onFileUploadSave;
			scope.sortType = 'uploadDate';
			scope.sortReverse = false;
			scope.currentRow = 0;

			setFilter('active');
			document.title = 'Contracts';
		}

		function registerEventHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_FILE_UPLOAD_SUCCESS, handler: onFileUploadSuccess },
					{ message: observerMessages.COB_OBSERVER_FILE_UPLOAD_SAVED, handler: onFileUploadSaved }
					//,{ message: observerMessages.COB_OBSERVER_FILE_UPLOAD_ERROR, handler: onError }
				]);
		}

		function dismissErrors() {
			scope.m.errors = [];
		}

		function setFilter(filter) {
			scope.selectedFilter = filter;
			getContracts();
		}

		function saveDescription(contract) {

			contractService.updateContractDescription(contract.contractId, contract.name, contract.description)
				.catch(function(res) {
					var modelErrors = res.data.modelState;
					var errors = [];
					for (var key in modelErrors) {
						for (var i = 0; i < modelErrors[key].length; i++) {
							errors.push(modelErrors[key][i]);
						}
					}

					observerService.sendMessageToSubject(scope,
						subjectMessages.COB_SUBJECT_GENERIC_SERVER_ERROR,
						errors);
					scope.m.errors = errors;
				});
		}

		function getContracts() {
			if (!scope.ajaxIsRunning) {
				scope.ajaxIsRunning = true;
				setTimeout(function() {
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
				},
				1);

				contractService.getContracts(scope.selectedFilter)
					.then(function(response) {
						scope.contracts = response.data.contracts;
					})
					.catch(function(e) {
						console.log(e);
						// alert('Unable to retrieve carriers');
					})
					.finally(function() {
						scope.ajaxIsRunning = false;
						observerService
							.sendMessageToSubject(scope,
								subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
					});
			}
		}

		function onFileUploadSuccess() {
			scope.disableUpload = true;
		}

		function onFileUploadSaved() {
			setFilter('active');
			scope.disableUpload = false;
		}

		function onFileUploadSave() {
			scope.newContract.save();
		}

		function onfileUploadCancel() {
			scope.newContract.reset();
			scope.disableUpload = false;
		}
	}
})();
